import userClient from 'packages/smart-home-support/api/userClient';
import { DeviceIcon, DynamicLink, FootnoteMarker, Grid, LoadingOverlay } from 'packages/smart-home-support/components';
import { DeviceCode } from 'packages/smart-home-support/models';
import { getDeviceDisclaimers, prevent } from 'packages/smart-home-support/utils';
import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { UserContext } from '../../../auth/UserProvider';
import { deviceTypes } from '../../data';
import { Devices } from '../../models';
import { Heading2, PageContainer } from '../../styles';
import { getBreakpoint, getTabUrl } from '../../utils';

const breakpoint = getBreakpoint();

const s = {
  Heading2,
  PageContainer: styled(PageContainer)`
    @media ${breakpoint} {
      padding-bottom: 100px;
    }
  `,
  DeviceGrid: styled(Grid)`
    margin-bottom: -20px;
    margin-right: -6.5px;
    @media ${breakpoint} {
      margin-right: -25px;
      margin-top: 50px;
    }
  `,
  Device: styled(DynamicLink)`
    padding: 0;
    background: none;
    border: none;
    width: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 6.5px;
    text-decoration: none;
    color: #000;
    @media ${breakpoint} {
      width: 120px;
      margin-right: 25px;
    }
  `,
  DeviceIconWrapper: styled.div`
    box-sizing: border-box;
    width: 72px;
    height: 72px;
    border-radius: 9999px;
    background-color: #f6f6f6;
    padding: 15px;
    @media ${breakpoint} {
      width: 120px;
      height: 120px;
      padding: 27px;
    }
  `,
  DeviceLabel: styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    margin-top: 7px;
    @media ${breakpoint} {
      font-size: 16px;
    }
  `,
  DisclaimersContainer: styled.div`
    margin-top: 70px;
  `,
  Disclaimer: styled.div`
    font-size: 14px;
  `,
};

const AddDevicePage = () => {
  const { user, setDevices } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [saveComplete, setSaveComplete] = useState(false);
  const deviceDisclaimers = getDeviceDisclaimers();

  const onDeviceClick = async (type: DeviceCode) => {
    setIsLoading(true);
    if (user) {
      const savedDevices = await userClient.saveDevice(user.home.devices as Devices, { type });
      setDevices(savedDevices);
    }
    setSaveComplete(true);
  };

  const disclaimers = [...Array.from(new Set(Object.values(deviceDisclaimers)))];

  return saveComplete ? (
    <Redirect to={`${getTabUrl('devices')}&addedDevices=1`} />
  ) : (
    <s.PageContainer>
      <LoadingOverlay in={isLoading || !user} isFullPage />
      <s.Heading2>Add device</s.Heading2>
      <p>Select device type</p>
      <s.DeviceGrid
        items={(Object.keys(deviceTypes) as Array<DeviceCode>).map((deviceType, i) => (
          <s.Device
            id={`add-device-${deviceType}`}
            className={`add-device-${deviceType}`}
            key={i}
            onClick={prevent(() => onDeviceClick(deviceType))}
          >
            <s.DeviceIconWrapper>
              <DeviceIcon deviceType={deviceType} />
            </s.DeviceIconWrapper>
            <s.DeviceLabel>
              {deviceTypes[deviceType].label}
              {deviceDisclaimers[deviceType] && <FootnoteMarker />}
            </s.DeviceLabel>
          </s.Device>
        ))}
      />
      <s.DisclaimersContainer>
        {disclaimers.map((disclaimer, i) => (
          <s.Disclaimer key={i}>
            <FootnoteMarker />
            {disclaimer}
          </s.Disclaimer>
        ))}
      </s.DisclaimersContainer>
    </s.PageContainer>
  );
};

export default AddDevicePage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/AddDevicePage/AddDevicePage.tsx